import React from 'react';
import './CardImg.css'

const CardImg = (props) => {
    return ( 
        <img className={props.ImgStyle} src={props.ImgSrc} alt="" />
     );
}
 
export default CardImg;